export default {"src":"/planos/_next/static/media/equifax-finance-chip.ec183406.svg","height":12,"width":20,"blurWidth":0,"blurHeight":0};